import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { toast } from "sonner";
import { Lock, Check, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

const CAT_COLORS = { healing: "#81B29A", goals: "#E07A5F", creator: "#F2CC8F" };

export default function Challenges() {
  const [items, setItems] = useState([]);

  const load = async () => { const r = await api.get("/challenges"); setItems(r.data); };
  useEffect(() => { load(); }, []);

  const join = async (ch) => {
    if (ch.locked) { toast("Premium challenge — upgrade to join."); return; }
    try {
      await api.post(`/challenges/${ch.challenge_id}/join`);
      setItems(items.map(x => x.challenge_id === ch.challenge_id ? { ...x, joined: true } : x));
      toast.success("You're in!");
    } catch (e) {
      if (e.response?.status === 402) toast("Premium challenge — upgrade to join.");
      else toast.error("Could not join");
    }
  };

  return (
    <div className="space-y-8" data-testid="challenges-page">
      <div>
        <p className="text-sm uppercase tracking-[0.2em] text-[#8A8D98]">Multi-day journeys</p>
        <h1 className="font-display text-4xl tracking-tight mt-2">Challenges & creator kits</h1>
        <p className="text-[#5b5f6e] mt-2 max-w-xl">Guided programs for healing, goal-setting and building your creator practice.</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {items.map((ch, i) => (
          <div key={ch.challenge_id} className={`soft-card p-6 rise-in rise-delay-${(i%4)+1}`} data-testid={`challenge-${ch.challenge_id}`}>
            <div className="flex items-center justify-between">
              <span className="tag-chip" style={{ background: (CAT_COLORS[ch.category] || "#2D3142") + "22", color: CAT_COLORS[ch.category] || "#2D3142" }}>
                {ch.category}
              </span>
              {ch.premium && <span className="tag-chip bg-[#2D3142] text-[#F2CC8F]">Premium</span>}
            </div>
            <h3 className="font-display text-2xl tracking-tight mt-4">{ch.title}</h3>
            <p className="text-[#5b5f6e] mt-2 leading-relaxed">{ch.description}</p>
            <div className="flex items-center gap-3 mt-5 text-sm text-[#8A8D98]">
              <span>{ch.days} days</span>
            </div>
            {ch.joined ? (
              <span className="mt-5 inline-flex items-center gap-2 pill-btn bg-[#81B29A] text-white">
                <Check className="w-4 h-4" /> Joined
              </span>
            ) : ch.locked ? (
              <Link to="/app/premium" className="mt-5 inline-flex items-center gap-2 pill-btn bg-[#F2CC8F]/60 text-[#8A5A2B] hover:bg-[#F2CC8F]" data-testid={`unlock-${ch.challenge_id}`}>
                <Lock className="w-4 h-4" /> Unlock with Premium
              </Link>
            ) : (
              <button onClick={()=>join(ch)} className="mt-5 pill-btn bg-[#2D3142] text-white hover:bg-[#E07A5F] inline-flex items-center gap-2" data-testid={`join-${ch.challenge_id}`}>
                Join <ArrowRight className="w-4 h-4" />
              </button>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
